export const CONDITION_PARAMS = [
  // Kiinteisto-level
  { key: 'kohteen_nimi',        label: 'Kohteen nimi',          source: 'card',      field: 'kohteen_nimi',        type: 'string' },
  { key: 'tontin_omistaja',     label: 'Tontin omistaja',       source: 'card',      field: 'tontin_omistaja',     type: 'string' },
  { key: 'kiinteistotunnus',    label: 'Kiinteistötunnus',      source: 'card',      field: 'kiinteistotunnus',    type: 'string' },
  { key: 'tontin_koko',         label: 'Tontin koko (m²)',      source: 'card',      field: 'tontin_koko',         type: 'number' },
  { key: 'rakennusten_lkm',     label: 'Rakennusten lkm',       source: 'card',      field: 'rakennusten_lkm',     type: 'number' },
  { key: 'ulkorakennusten_lkm', label: 'Ulkorakennusten lkm',  source: 'card',      field: 'ulkorakennusten_lkm', type: 'number' },
  { key: 'huoneistojen_lkm',    label: 'Huoneistojen lkm',     source: 'card',      field: 'huoneistojen_lkm',    type: 'number' },
  // Rakennus-level
  { key: 'osoite',              label: 'Osoite',                source: 'rakennus0', field: 'osoite',              type: 'string' },
  { key: 'toimipaikka',         label: 'Toimipaikka',           source: 'rakennus0', field: 'toimipaikka',         type: 'string' },
  { key: 'postinumero',         label: 'Postinumero',           source: 'rakennus0', field: 'postinumero',         type: 'string' },
  { key: 'rakennusvuosi',       label: 'Rakennusvuosi',         source: 'rakennus0', field: 'rakennusvuosi',       type: 'number' },
  { key: 'peruskorjausvuosi',   label: 'Peruskorjausvuosi',    source: 'rakennus0', field: 'peruskorjausvuosi',   type: 'number' },
  { key: 'laajennusvuosi',      label: 'Laajennusvuosi',        source: 'rakennus0', field: 'laajennusvuosi',      type: 'number' },
  { key: 'kokonaisala',         label: 'Kokonaisala (m²)',      source: 'rakennus0', field: 'kokonaisala',         type: 'number' },
  { key: 'kerrosala',           label: 'Kerrosala (m²)',        source: 'rakennus0', field: 'kerrosala',           type: 'number' },
  { key: 'huoneistoala',        label: 'Huoneistoala (m²)',     source: 'rakennus0', field: 'huoneistoala',        type: 'number' },
  { key: 'tilavuus',            label: 'Tilavuus (m³)',         source: 'rakennus0', field: 'tilavuus',            type: 'number' },
];

export const NUMBER_OPS = [
  { op: '<',  label: '< (pienempi kuin)' },
  { op: '<=', label: '<= (pienempi tai yhtä suuri)' },
  { op: '>',  label: '> (suurempi kuin)' },
  { op: '>=', label: '>= (suurempi tai yhtä suuri)' },
  { op: '=',  label: '= (yhtä suuri)' },
  { op: '!=', label: '≠ (eri kuin)' },
];

export const STRING_OPS = [
  { op: '=',        label: '= (täsmälleen)' },
  { op: '!=',       label: '≠ (eri kuin)' },
  { op: 'contains', label: 'sisältää' },
];

// Module-level tags cache: [{ id, nimi, report_types }]
// Populated by any component that fetches /api/valmislauseet/tagit
let _tagsCache = null;

export function setTagsCache(tags) { _tagsCache = tags; }
export function getTagsCache() { return _tagsCache ?? []; }
export function getTagIdByNimi(nimi) {
  return _tagsCache?.find(t => t.nimi === nimi)?.id ?? null;
}
export function isTagsCacheReady() { return _tagsCache !== null; }

// Tags scoped to this report type, plus universal ones (no report_types at
// all) — same "no rows = universal" rule the backend join table uses.
// Shared here so every admin-view layout filters/groups the same way
// instead of each re-implementing this check.
export function getTagsForReportType(reportType) {
  return getTagsCache().filter(t => !t.report_types?.length || t.report_types.includes(reportType));
}

export function extractParamValue(paramKey, rakennusData, mergedRakennusData) {
  const def = CONDITION_PARAMS.find(p => p.key === paramKey);
  if (!def) return null;
  const src = mergedRakennusData || rakennusData;
  if (!src) return null;
  if (def.source === 'card') return src[def.field] ?? null;
  if (def.source === 'rakennus0') {
    const r = src?.rakennukset_fulls?.find(r => r.isMainBuilding) || src?.rakennukset_fulls?.[0];
    return r?.[def.field] ?? null;
  }
  return null;
}

export function evalCondition(condition, rakennusData, mergedRakennusData) {
  if (!condition) return null;
  const raw = extractParamValue(condition.param, rakennusData, mergedRakennusData);
  if (raw == null || raw === '') return null;
  const def = CONDITION_PARAMS.find(p => p.key === condition.param);
  if (def?.type === 'number') {
    const n = parseFloat(raw);
    if (isNaN(n)) return null;
    const v = Number(condition.value);
    if (condition.operator === '<')  return n < v;
    if (condition.operator === '<=') return n <= v;
    if (condition.operator === '>')  return n > v;
    if (condition.operator === '>=') return n >= v;
    if (condition.operator === '=')  return n === v;
    if (condition.operator === '!=') return n !== v;
  }
  if (def?.type === 'string') {
    const s = String(raw).toLowerCase();
    const cv = String(condition.value).toLowerCase();
    if (condition.operator === '=')        return s === cv;
    if (condition.operator === '!=')       return s !== cv;
    if (condition.operator === 'contains') return s.includes(cv);
  }
  return null;
}
